import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "1rem",
    width: "100%",
  },
  buttonSubContainer: {},
  primaryButton: theme.primaryBlueButton,
  secondaryButton: theme.secondaryBlueButton,
  firstCap: {
    textTransform: "lowercase !important",
    "&:first-letter": {
      textTransform: "capitalize !important",
    },
  },
}));

const FormButtonGroupComponent = ({ onSave, onCancel, onDelete, tab }) => {
  const classes = useStyles();
  const intl = useIntl();

  const newPatient = !!JSON.parse(localStorage.getItem("genome-new-patient"));

  const {
    patientData,
    patientId,
    gender,
    birthDate,
    residentialZipCode,
    birthZipCode,
    comments,
    symptoms,
    diseases,
    familyBackgrounds,
    patientBackgrounds,
  } = useSelector((state) => state.patient);

  const {
    displayedPatientBackgrounds,
    displayedSymptoms,
    displayedFamilyBackgrounds,
    displayedDiseases,
    diseasesSelectedToRemove,
    symptomsSelectedToRemove,
    patientBackgroundsSelectedToRemove,
    familyBackgroundsSelectedToRemove,
  } = useSelector((state) => state.searchOmim);

  const oldUser = {
    patient_id: patientData?.patient_id,
    birth_date: patientData?.birth_date,
    gender: patientData?.gender,
    birth_zip_code: patientData?.birth_zip_code,
    residential_zip_code: patientData?.residential_zip_code,
    comments: patientData?.comments,
  };

  const newUser = {
    patient_id: patientId,
    birth_date: !!birthDate ? new Date(birthDate).getTime() : null,
    gender: gender,
    birth_zip_code: +birthZipCode,
    residential_zip_code: +residentialZipCode,
    comments,
  };

  const isButtonDisabled = () => {
    switch (tab) {
      case 0:
        return JSON.stringify(oldUser) === JSON.stringify(newUser);
      case 1:
        return (
          JSON.stringify(displayedPatientBackgrounds) === JSON.stringify(patientBackgrounds) &&
          !patientBackgroundsSelectedToRemove?.length
        );
      case 2:
        return JSON.stringify(displayedSymptoms) === JSON.stringify(symptoms) && !symptomsSelectedToRemove?.length;
      case 3:
        return (
          JSON.stringify(displayedFamilyBackgrounds) === JSON.stringify(familyBackgrounds) &&
          !familyBackgroundsSelectedToRemove?.length
        );
      case 4:
        return JSON.stringify(displayedDiseases) === JSON.stringify(diseases) && !diseasesSelectedToRemove?.length;
      default:
        return false;
    }
  };

  return (
    <div className={classes.buttonContainer}>
      <Button className={classes.primaryButton} onClick={onSave} disabled={isButtonDisabled()}>
        <Typography className={classes.firstCap}>{intl.formatMessage({ id: "patientForm_save" })}</Typography>
      </Button>
      <Button className={classes.secondaryButton} onClick={onCancel}>
        <Typography className={classes.firstCap}>{intl.formatMessage({ id: "patientForm_cancel" })}</Typography>
      </Button>
      <Button className={classes.secondaryButton} onClick={onDelete} disabled={newPatient || !patientData?.id}>
        <Typography className={classes.firstCap}>{intl.formatMessage({ id: "patientForm_delete" })}</Typography>
      </Button>
    </div>
  );
};

FormButtonGroupComponent.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default FormButtonGroupComponent;
